// NOTE: This file should mirror the CSS breakpoints.

/**
 * @deprecated use weave CSS globals.MEDIUM_BREAKPOINT instead
 */
export const tabletBreakpoint = 768;

/**
 * @deprecated
 * Warning: does not update if window is resized so value may become stale.
 * Use `useWindowSize` hook instead if value needs to be up-to-date on window resize.
 */
export const isTablet = () => window.innerWidth <= tabletBreakpoint;
